import AvailabilityCache from './availability-cache';

// manages availability
export default class AvailabilityService {

  static get defaults() {
    return {
      // max horizon to load (in days)
      horizon: 60,
      // max batch size
      batchSize: 5,
      // max concurrent requests
      concurrency: 3,
      // number of days to preload
      preload: 12,
      // IANA timezone
      timezone: 'America/New_York',
      // place_id
      place_id: null
    };
  }

  /**
   * AvailabilityService constructor
   * @method constructor
   * @param  {Object}    [opts={}] – see `defaults`
   * @return {AvailabilityService}
   */

  constructor( opts = {} ) {
    this._options = Object.assign( {}, AvailabilityService.defaults, opts );
    this._createCache();
  }

  /**
   * Create an AvailabilityCache instance
   * @method _createCache
   * @return {undefined}
   */

  _createCache() {
    const opts = Object.assign( {}, this._options );
    this._cache = new AvailabilityCache( opts );
  }

  /**
   * Return an array of AvailabilityDays for each day between now and `horizon`
   * @method dates
   * @return {Array<AvailabilityDay>}
   */

  dates() {
    return this._cache.list();
  }

  /**
   * Start pre-fetching
   * @method start
   * @return {undefined}
   */

  start() {
    this._cache.start();
  }

  /**
   * Load slots for the diven date
   * @method load
   * @param  {Date} date – target date (does not need to be zeroed out)
   * @return {Promise<Array<AvailabilitySlot>>}
   */

  load( date ) {
    const key = AvailabilityCache.keyFor( date, this._options.timezone );
    return this._cache.load( key );
  }

  /**
   * Reset the cache
   * @method reset
   */

  reset() {
    this._cache.reset();
  }

}
